import { render, staticRenderFns } from "./selectGoodsMonitor.vue?vue&type=template&id=180ff03e&scoped=true"
import script from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
export * from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
import style0 from "./selectGoodsMonitor.vue?vue&type=style&index=0&id=180ff03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ff03e",
  null
  
)

export default component.exports